import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxReloadable } from "../../Lib/AxSystem/AxReloadable";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";

@ModuleName("ShoppingCartReservationTimer")
export class ShoppingCartReservationTimer implements AxInit, AxReloadable {
    private companyDateTime: moment.Moment;
    private countDown: number;

    constructor(
        private _i18NHelper: I18nHelper = new I18nHelper(),
        private axLoading: AxLoading = new AxLoading(),
    ) { }

    AxInit(): void {
        this.axLoading = new AxLoading();
        sessionStorage.removeItem('shoppingCartReservationTimes');
        this.loadReservationTimes();
    }

    AxReload(): void {
        clearInterval(this.countDown);
        this.loadReservationTimes();
    }

    public loadReservationTimes() {
        const $reservationTimeHolders = $('.cartEntryCd');
        $reservationTimeHolders.each((_, el) => this.axLoading.ShowLoadingIndicator(el));
        const fromSession = sessionStorage.getItem('shoppingCartReservationTimes');
        const times: ShoppingCartReservationTimes = JSON.parse(fromSession || '""');

        if (fromSession && times?.CartEntryReservationTimes?.length > 0) {
            $reservationTimeHolders.each((_, el) => this.axLoading.HideLoadingIndicator(el));
            this.setCountDownsFromResult(times);
        } else {
            AxessViewer.ajaxRequest(
                '/api/ShoppingCartReservationTimeApi/getReservationTimes',
                null,
                (result: ShoppingCartReservationTimes) => {
                    $reservationTimeHolders.each((_, el) => this.axLoading.HideLoadingIndicator(el))
                    if (result?.CartEntryReservationTimes?.length > 0) {
                        result.SavedLocalTime = new Date().toISOString();
                        sessionStorage.setItem('shoppingCartReservationTimes', JSON.stringify(result));
                        this.setCountDownsFromResult(result);
                    }
                }
            );
        }
    }

    setCountDownsFromResult(result: ShoppingCartReservationTimes) {
        (result.CartEntryReservationTimes || []).forEach((e) => {
            const holderElement = `.cartEntryReservationCd_${e.CartEntryId}`;
            const finishLocalTime = moment(result.SavedLocalTime, 'YYYY-MM-DDTHH:mm:ss.SSSSZ');
            const currentLocalTime = moment(new Date().toISOString(), 'YYYY-MM-DDTHH:mm:ss.SSSSZ');
            const enlapsedLocalTime = moment.duration(finishLocalTime.diff(currentLocalTime));
            this.companyDateTime = moment(result.CompanyTime, 'YYYY-MM-DD HH:mm:ss').subtract(enlapsedLocalTime);
            this.momentCountDown(e.ReservedUntil, holderElement);
        });
    }

    momentCountDown(reservationEndTimeString: string, holderElement: string) {
        const eventTime = moment(reservationEndTimeString, 'YYYY-MM-DDTHH:mm:ss');
        const duration = moment.duration(eventTime.diff(this.companyDateTime));
        const interval = 1000;
        const intervalMoment = moment.duration(interval, 'milliseconds');
        $(holderElement).parent().removeClass('d-none');

        this.countDown = setInterval((_) => {
            const remaining = duration.subtract(intervalMoment);
            if (remaining.asMilliseconds() <= 0) {
                clearInterval(this.countDown);
                $(holderElement).html(this._i18NHelper.GetTranslation(Translations.ReservationExpired));
                sessionStorage.removeItem('shoppingCartReservationTimes');
                window.location.reload();
            } else {
                const minutes = remaining.minutes() < 10 ? `0${remaining.minutes()}` : remaining.minutes();
                const seconds = remaining.seconds() < 10 ? `0${remaining.seconds()}` : remaining.seconds();
                const days = remaining.days() > 0 ? `${remaining.days()}:` : '';
                $(holderElement).html(`${days}${remaining.hours()}:${minutes}:${seconds}`);
            }
        }, interval);
    }
}

export class ShoppingCartReservationTimes {
    CompanyTime: string;
    CartEntryReservationTimes: CartEntryReservationTime[];
    SavedLocalTime: string;
}

export class CartEntryReservationTime {
    CartEntryId: number;
    ReservedUntil: string;
}